import React from 'react'
import UpdateTypeForm from '../../../component/form/vehicle-managment/type/UpdateTypeForm'

export default function UpdateType() {
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className='layout_head'>
                            <h5>Update Vehicle Type</h5>
                            <UpdateTypeForm />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
